import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

interface ApiErrorDetail {
    status: number;
    message: string;
    errorDescription?: string;
    errorCode?: string | number;
}

const ErrorHandler: React.FC = () => {
    const [open, setOpen] = useState(false);
    const [errorDetail, setErrorDetail] = useState<ApiErrorDetail | null>(null);

    useEffect(() => {
        const handler = (event: Event): void => {
            const customEvent = event as CustomEvent<ApiErrorDetail>;
            setErrorDetail(customEvent.detail);
            setOpen(true);
        };

        window.addEventListener('api-error', handler);
        return () => {
            window.removeEventListener('api-error', handler);
        };
    }, []);

    const handleClose = (): void => {
        setOpen(false);
    };

    return (
        <Dialog open={open} aria-labelledby="api-error-dialog-title">
            <DialogTitle id="api-error-dialog-title">{errorDetail?.status ? `Error ${errorDetail.status}` : 'Error'}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {errorDetail?.errorDescription || errorDetail?.message || 'Something went wrong.'}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ErrorHandler;
